import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import type { Localizations } from '@/types';
import { mainDomain } from '@/utils/variables';

export const useLocalizationsStore = defineStore('localizations', () => {
    const localizations = ref<Localizations[]>([]);
    const defaultLanguageCode = ref<string>('');
    const awaitGetLocalizations = async () => {
        try {
            const response = await axios.get<Localizations[]>(`/main-api/translations/public?domain=${mainDomain}`);
            if (response.status === 200) {
                localizations.value = response.data;
            }
        } catch (error) {
            console.error(error);
        }
    };
    const awaitGetDefaultLanguageCode = async () => {
        try {
            const response = await axios.get<{ language_code: string }>(`/main-api/informational/default_language_code`);
            if (response.status === 200) {
                defaultLanguageCode.value = response.data.language_code;
            }
        } catch (error) {
            console.error(error);
        }
    };
    return { localizations, defaultLanguageCode, awaitGetLocalizations, awaitGetDefaultLanguageCode };
});
